import * as React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import Header from "../../Layouts/Header";
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import {RxLapTimer} from "react-icons/rx";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';


ChartJS.register(ArcElement, Tooltip, Legend);

let label = [];
let count = [];
const currencyFormat = Intl.NumberFormat('en-US');
export default function Regions() {
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [dateFrom, setDateFrom] = React.useState('');
    const [dateTo, setDateTo] = React.useState('');
    const [duration, setDuration] = React.useState('بازه انتخابی');
    const [vendors, setVendors] = React.useState([]);
    const [basics, setBasics] = React.useState([]);
    const [brand, setBrand] = React.useState('');
    const [data, setData] = React.useState([]);

    let sumAll = 0;
    let sumSale = 0;
    let sumReturn = 0;

    React.useEffect(() => {
        const params = {
            processFor: 'Sales',
        }
        API.getBasics(params)
            .then((response) => {
                setBasics(response.data)
                setIsLoaded(true)
            })
            .catch((error) => {

            });
        setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        }, 400)
    }, []);


    const onLoadReport = () => {


        if(dateFrom.length < 3 || dateTo.length < 3) {
            toast.error('بازه تاریخی را انتخاب کنید');
            return false
        }

        const toMonth = dateTo?.toDate?.().getMonth() -(-1);
        const fromMonth = dateFrom?.toDate?.().getMonth() -(-1);
        const params = {
            date_from : dateFrom?.toDate?.().getFullYear() + '-' + fromMonth + '-' + dateFrom?.toDate?.().getDate() + ' 00:00' ,
            date_to : dateTo?.toDate?.().getFullYear() + '-' + toMonth + '-' + dateTo?.toDate?.().getDate() + ' 23:59' ,
            brand_id: brand
        }
        setIsLoaded(false)
        setDuration('بازه انتخابی')
        API.getRegionReport(params)
            .then((response) => {
                setIsLoaded(true);
                setVendors(response.data.vendors)
                response.data.vendors.forEach(element => {
                    label.push(element.name);
                    count.push(element.bcount);
                });
                const data2 = {
                    labels: label,
                    datasets: [
                        {
                            label: 'تعداد باتری',
                            data: count,
                            backgroundColor: [
                                'rgba(255, 99, 132, 0.2)',
                                'rgba(54, 162, 235, 0.2)',
                                'rgba(255, 206, 86, 0.2)',
                                'rgba(75, 192, 192, 0.2)',
                                'rgba(153, 102, 255, 0.2)',
                                'rgba(255, 159, 64, 0.2)',
                                'rgba(25, 57, 64, 0.2)',
                                'rgba(155, 111, 64, 0.2)',
                                'rgba(99, 222, 64, 0.2)',
                            ],
                            borderColor: [
                                'rgba(255, 99, 132, 1)',
                                'rgba(54, 162, 235, 1)',
                                'rgba(255, 206, 86, 1)',
                                'rgba(75, 192, 192, 1)',
                                'rgba(153, 102, 255, 1)',
                                'rgba(255, 159, 64, 1)',
                                'rgba(255, 159, 64, 1)',
                                'rgba(255, 159, 64, 1)',
                                'rgba(255, 159, 64, 1)',
                            ],
                            borderWidth: 1,
                        },
                    ],
                };

                setData(data2)
            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });

    }

    return (
        <React.Fragment>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <Header hasBack={true} title='NGKH'/>
            <section className='container-fluid my-3 py-5 rtl'>
                <div className="row">
                    <div className="col-12">
                        <div className="card info-card ">

                            <div className="card-body rtl row pt-4">
                                <div className="col-5 mb-2">
                                <span className='text-small-2 mx-3'>
                                    از تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateFrom(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-1">
                                    &nbsp;
                                </div>
                                <div className="col-5 mb-2">
                            <span className='text-small-2 mx-3'>
                                    تا تاریخ
                                </span>
                                    <DatePicker
                                        onChange={(val) => setDateTo(val)}
                                        calendar={persian}
                                        locale={persian_fa}
                                        calendarPosition="bottom-right"
                                        className="rmdp-mobile"

                                    />
                                </div>
                                <div className="col-12 mb-3">
                                    <label htmlFor="floatingInput" className="mb-2 text-muted text-small-3">
                                        برند
                                    </label>
                                    <select
                                        className="form-control text-center text-small-1"
                                        id="floatingInput"

                                        value={brand}
                                        onChange={
                                            (event) => {
                                                setBrand(event.target.value)
                                            }
                                        }
                                    >
                                        <option value="0">
                                            انتخاب برند
                                        </option>
                                        {
                                            basics?.brands?.map(bt => {
                                                return (
                                                    <option value={bt.id} key={bt.id}>
                                                        {bt.name}
                                                    </option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                                <div className="col-12 mb-2">
                                    <button className='btn btn-warning w-100 text-small-2'
                                            onClick={onLoadReport}
                                    >
                                        مشاهده گزارش
                                    </button>
                                </div>
                                {
                                    vendors.length < 1 &&

                                    <div className="col-12 mt-3">
                                        <div className="alert alert-warning alert-dismissible fade show text-center text-small-2 " role="alert">
                                            <RxLapTimer className='ms-2' />
                                            توجه داشته باشید که به دلیل حجم بالای اطلاعات قابل پردازش، دریافت این گزارش -بسته به بازه انتخابی- ممکن است تا حدود ۲۰ ثانیه  طول بکشد. لطفا برای دریافت گزارش صبور باشید

                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className=' mt-3 alert alert-light text-center'>
                            گزارش عملکرد استانی در
                            &nbsp;
                            {
                                duration
                            }
                        </div>
                        <table className="table rtl mt-1 table-striped">
                            <thead className='text-small-2'>
                            <tr>
                                <th scope="col">#</th>
                                <th scope="col">استان</th>
                                <th scope="col">تعدادی</th>
                                <th scope="col">آمپری</th>
                                <th scope="col">برگشتی</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                vendors.map((vendor, index) => {
                                    sumAll += parseInt(vendor.bcount);
                                    sumSale += parseInt(vendor.amp);
                                    sumReturn += parseInt(vendor.rcount);

                                    return (
                                        <tr key={index}>
                                            <th scope="row">{index + 1}</th>
                                            <td>{vendor.name}</td>
                                            <td>
                                                {currencyFormat.format(vendor.bcount)}
                                            </td>
                                            <td>
                                                {currencyFormat.format(vendor.amp)}
                                            </td>
                                            <td>

                                                {
                                                    vendor.bcount > 0 ? Math.ceil(vendor.rcount * 100 / vendor.bcount) : 0
                                                }
                                                %
                                                &nbsp;
                                                <span className='text-muted text-small-2 fw-normal'>({vendor.rcount})</span>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            <tr >
                                <th scope="col" className='text-success'></th>
                                <th scope="col" className='text-success'>مجموع</th>
                                <th scope="col" className='text-success'>
                                    {currencyFormat.format(sumAll)}
                                </th>
                                <th scope="col" className='text-success'>
                                    {currencyFormat.format(sumSale)}
                                </th>
                                <th scope="col" className='text-success'>{ sumReturn }
                                    &nbsp;
                                    عدد
                                </th>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='row py-4'>
                    <div className="col-12 text-center py-3 text-info">
                        نمودار فروش تعدادی
                    </div>
                    <div className="col-12 mt-4">

                        {
                            vendors.length > 1 && <Pie data={data} />
                        }
                    </div>
                </div>
            </section>


        </React.Fragment>
    );

}